<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="69" height="67" viewBox="0 0 69 67">
        <text id="_" data-name="💊" fill="#707070" font-size="50" font-family="SegoeUIEmoji, Segoe UI Emoji"><tspan x="0" y="54">💊</tspan></text>
    </svg>
</template>

<script>
export default {
    name: "Lab",
};
</script>

<style scoped></style>
